import Link from 'next/link'

type IconNames = 'x' | 'github' | 'linkedin'

export default function SocialLink({
  name,
  link,
}: {
  name: IconNames
  link: string
}) {
  return (
    <Link
      href={link}
      target='_blank'
      className="transition-color flex h-[30px] w-[30px] items-center justify-center rounded-[6.429px] bg-white/10 duration-300 hover:bg-[#38BDF9]"
    >
      {icons[name]}
    </Link>
  )
}

const icons: Record<IconNames, JSX.Element> = {
  x: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M0.5 0.262939L7.04557 9.80533L0.638637 17.2272H2.05814L7.67249 10.7191L12.1368 17.2272H17.5L10.6615 7.25843L16.6961 0.262939H15.2809L10.0337 6.34203L5.86323 0.262939H0.5ZM2.19503 1.15579H5.39327L15.805 16.3343H12.6067L2.19503 1.15579Z"
        fill="white"
      />
    </svg>
  ),
  github: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0.391602C4.75363 0.391602 0.5 4.64523 0.5 9.8916C0.5 14.3431 3.56533 18.0679 7.69783 19.0987C7.6535 18.9704 7.625 18.8216 7.625 18.6371V17.0134C7.23946 17.0134 6.59346 17.0134 6.43117 17.0134C5.78121 17.0134 5.20329 16.734 4.92304 16.2146C4.61192 15.6375 4.55808 14.7548 3.787 14.2149C3.55821 14.0352 3.73237 13.8301 3.996 13.8579C4.48288 13.9956 4.88662 14.3297 5.26662 14.8253C5.64504 15.3216 5.82317 15.4341 6.53012 15.4341C6.87292 15.4341 7.38592 15.4143 7.86883 15.3383C8.1285 14.6788 8.57738 14.0716 9.126 13.785C5.9625 13.4596 4.45279 11.8858 4.45279 9.7491C4.45279 8.82918 4.84467 7.93935 5.51046 7.18964C5.29196 6.44548 5.01725 4.92785 5.59438 4.34994C7.01779 4.34994 7.87833 5.27302 8.08496 5.52239C8.79429 5.27935 9.57329 5.1416 10.3919 5.1416C11.212 5.1416 11.9942 5.27935 12.7051 5.52398C12.9094 5.27619 13.7707 4.34994 15.1973 4.34994C15.7768 4.92864 15.4989 6.4526 15.278 7.19519C15.9399 7.94331 16.3294 8.83077 16.3294 9.7491C16.3294 11.8842 14.822 13.4573 11.6633 13.7842C12.5325 14.2379 13.1667 15.5124 13.1667 16.4727V18.6371C13.1667 18.7195 13.1485 18.7789 13.139 18.8493C16.8408 17.5518 19.5 14.0368 19.5 9.8916C19.5 4.64523 15.2464 0.391602 10 0.391602Z"
        fill="white"
      />
    </svg>
  ),
  linkedin: (
    <svg
      fill="white"
      height="18px"
      width="18px"
      className="rounded-sm"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 455.00 455.00"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path d="M246.4,204.35v-0.665c-0.136,0.223-0.324,0.446-0.442,0.665H246.4z"></path>
          <path d="M0,0v455h455V0H0z M141.522,378.002H74.016V174.906h67.506V378.002z M107.769,147.186h-0.446C84.678,147.186,70,131.585,70,112.085c0-19.928,15.107-35.087,38.211-35.087 c23.109,0,37.31,15.159,37.752,35.087C145.963,131.585,131.32,147.186,107.769,147.186z M385,378.002h-67.524V269.345 c0-27.291-9.756-45.92-34.195-45.92c-18.664,0-29.755,12.543-34.641,24.693c-1.776,4.34-2.24,10.373-2.24,16.459v113.426h-67.537 c0,0,0.905-184.043,0-203.096H246.4v28.779c8.973-13.807,24.986-33.547,60.856-33.547c44.437,0,77.744,29.02,77.744,91.398V378.002 z"></path>
        </g>
      </g>
    </svg>
  ),
}
